import { render, staticRenderFns } from "./GDanTransfer.vue?vue&type=template&id=522feb71&scoped=true&"
import script from "./GDanTransfer.vue?vue&type=script&lang=js&"
export * from "./GDanTransfer.vue?vue&type=script&lang=js&"
import style0 from "./GDanTransfer.vue?vue&type=style&index=0&id=522feb71&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522feb71",
  null
  
)

export default component.exports